import { Dialog, Button, DialogContent, DialogActions, DialogContentText} from "@mui/material"
import { useGetIdentity, useRedirect, useTranslate } from "react-admin"

interface IProps {
  message?: string
  actionButtonText?: string
  open: boolean
  handleClose?: () => void
}

const MailValidationFailedDialog = ({message, actionButtonText, open, handleClose}:IProps) => {
  
  const translate = useTranslate()
  const redirect = useRedirect()
  const { data: identity, isLoading } = useGetIdentity()

  if(isLoading || !identity) return null


  const handleConfig = () => {
    redirect(`/users/${identity.id}/mailServiceConfig/edit`)
  }

  return (
    <Dialog 
      open={open} 
      onClose={handleClose}
    >
      <DialogContent>
        <DialogContentText>
          {message && translate(message)}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} >{translate('ra.action.cancel')}</Button>
        {
          actionButtonText &&
          <Button onClick={handleConfig} >{translate(actionButtonText)}</Button>
        }
      </DialogActions>
    </Dialog>
  )
}

export default MailValidationFailedDialog